import React from 'react';
import Footer from '../Footer/Footer';
import './TermsOfService.css';

function TermsOfService() {
  return (
    <>
      <div className="terms-container">
        <header className="terms-header">
          <h1>Terms of Service</h1>
          <p>Last updated: January 2026</p>
        </header>
        <section className="terms-content">
          <h2>1. Terms of Service</h2>
          <p><b>1.1 Acceptance of Terms</b><br />
            By creating an account or otherwise using our halwaa application ("App"),
            you agree to these Terms of Service ("Terms"). If you do not agree with
            these Terms, do not use the App. These Terms apply to all users in the
            United States and any other locations where the App may be made available.
          </p>

          <p><b>1.2 Eligibility</b><br />
            You must be at least 13 years old (or older if required by your local
            jurisdiction) to use this App. By using the App, you represent and warrant
            that you have the right, authority, and capacity to enter into these Terms.
          </p>

          <p><b>1.3 Public Profiles</b><br />
            The App allows you to create a public profile. Any information, including
            photos and usernames, that you submit in your profile can be visible to
            other users. You are responsible for the content you share. We reserve
            the right to remove any content that violates these Terms, without notice.
          </p>

          <p><b>1.4 User Content</b><br />
            You retain all rights to the content you post or share within the App. By
            submitting content, you grant us a worldwide, non-exclusive, royalty-free
            license to use, reproduce, modify, adapt, publish, and display such content
            solely for the purpose of operating and improving the App.
          </p>

          <p><b>1.5 Location Data</b><br />
            This App may collect your location data to recommend nearby halal
            restaurants. By enabling location services, you consent to our collection
            and use of your location data for the purpose of providing you with
            location-based features.
          </p>

          <p><b>1.6 Photos and Media</b><br />
            You may choose to upload photos to your public profile or when submitting
            reviews. By doing so, you confirm that you have the legal right to share
            these photos and grant us permission to display them in the App.
          </p>

          <p><b>1.7 Prohibited Conduct</b><br />
            You agree not to engage in any of the following prohibited activities:
            <ul>
              <li>Upload or share content that is illegal, offensive, defamatory,
                harassing, or infringes on any intellectual property or privacy right.</li>
              <li>Use the App for any commercial purpose without our prior written consent.</li>
              <li>Submit false or misleading information, including fake reviews or
                fraudulent restaurant listings.</li>
              <li>Post lewd or inappropriate photos that violate community standards.</li>
              <li>Scrape, crawl, or otherwise extract data from the App without
                express permission. Automatic or manual scraping of user data is strictly prohibited.</li>
            </ul>
          </p>

          <p><b>1.8 Disclaimers</b><br />
            We do not guarantee the accuracy, reliability, or safety of any third-party
            or user-generated content (including restaurant locations or reviews). The
            App is provided "as is" without warranties of any kind.
          </p>

          <p><b>1.9 Limitation of Liability</b><br />
            To the fullest extent permitted by law, we are not liable for any direct,
            indirect, incidental, special, or consequential damages arising out of or
            related to your use or inability to use the App.
          </p>

          <p><b>1.10 User Bans and Termination</b><br />
            We reserve the right to suspend or ban any user who violates these Terms or
            otherwise engages in prohibited conduct, including but not limited to
            submitting false information or lewd photos. We also reserve the right to
            terminate or restrict your access to the App at any time for any reason.
          </p>

          <p><b>1.11 Changes to the Terms</b><br />
            We may update these Terms at any time. If we make changes, we will provide
            notice within the App or via other communications. Continued use after any
            changes indicates your acceptance of the new Terms.
          </p>

          <p><b>1.12 Contact Us</b><br />
            If you have questions or concerns about these Terms, please contact us at{' '}
            <a href="mailto:support@findhalal.us">support@findhalal.us</a>
          </p>

          <h2>2. Privacy Policy</h2>
          <p><b>2.1 Information We Collect</b><br />
            <ul>
              <li><b>Location Data:</b> With your permission, we collect approximate or
                precise location data to recommend nearby halal restaurants. You can disable
                location sharing at any time in your device settings; however, some
                location-based features may not work if you do so.</li>
              <li><b>Photos:</b> If you choose to upload photos to your public profile
                or to review restaurants, we collect and store these photos.</li>
              <li><b>Profile Information:</b> We collect your username, name, bio, and
                any other info you choose to share in your public profile.</li>
              <li><b>Usage Data:</b> We collect information about how you interact with
                the App (e.g., what pages you visit, which restaurants you favorite, etc.).</li>
            </ul>
          </p>

          <p><b>2.2 How We Use Your Information</b><br />
            <ul>
              <li>Provide and improve the App's functionality (e.g., showing halal
                restaurants near you).</li>
              <li>Communicate with you about updates or promotions (if you opt in).</li>
              <li>Analyze usage to improve user experience and develop new features.</li>
              <li>Enforce our Terms of Service and comply with legal obligations.</li>
            </ul>
          </p>

          <p><b>2.3 Sharing Your Information</b><br />
            <ul>
              <li>We do not sell your personal information to third parties.</li>
              <li>We may share location data and usage analytics with service
                providers or analytics partners for our internal use only.</li>
              <li>We may share necessary information if required by law or to respond
                to lawful requests by public authorities.</li>
            </ul>
          </p>

          <p><b>2.4 Data Retention</b><br />
            We retain your data as long as your account is active or as needed to
            provide our services. You can request account deletion at any time by
            emailing us at <a href="mailto:support@findhalal.us">support@findhalal.us</a>.
          </p>

          <p><b>2.5 Security</b><br />
            We employ industry-standard security measures to protect your information.
            However, no method of online transmission or storage is 100% secure. We
            cannot guarantee absolute security.
          </p>

          <p><b>2.6 Children's Privacy</b><br />
            Our App is not intended for children under 13. If you are aware of a user
            under 13 who has provided personal information, please contact us to have
            their data removed.
          </p>

          <p><b>2.7 Changes to this Privacy Policy</b><br />
            We may update our Privacy Policy from time to time. If we make significant
            changes, we will notify you within the App. Continued use of the App after
            any changes indicates acceptance of the new policy.
          </p>

          <p><b>2.8 Contact Us</b><br />
            If you have any questions about this Privacy Policy or our data practices,
            please contact us at <a href="mailto:privacy@findhalal.us">privacy@findhalal.us</a>
          </p>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default TermsOfService;